export default __webpack_public_path__ + "static/media/veksla_logo_vertical.ba6d29c9.svg";